import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/core/store";
import KeyCode from "@/assets/constants/key-code";

export interface ActiveKeyState {
  activeKey: KeyCode | null;
}

const initialState: ActiveKeyState = {
  activeKey: null, // зажатая клавиша
};

const activeKeySlice = createSlice({
  name: "homeMenuSlice",
  initialState,
  reducers: {
    setActiveKey: (state, action: PayloadAction<KeyCode | undefined>) => {
      state.activeKey = action.payload || null;
    },
  },
});

export const activeKeySelector = (state: RootState) => state.activeKey.activeKey;

export const activeKeyReducer = activeKeySlice.reducer;
export const { setActiveKey } = activeKeySlice.actions;
